import 'phaser'
import { l } from '../lib/imports'
import { createId } from '../main/common'
import { fi32 } from '../main/frameInfo'
import { layers } from '../main/layers-sidecar'

import { spriteMap } from './../main/spriteMap-sidecar'
import { IFrameAnim, IFrameAnimData } from '../engine/anims'
import { anims } from '../engine/anims-sidecar'
import { IEntity } from './entitiesUtils'
import { entitiesUtils } from './entitiesUtils-sidecar'
import { ITileMapShip } from '../tiles/tileMapShip'
import { ITileDataShip } from '../tiles/tilesDataShip'

export interface IObject extends IEntity {
  image: Phaser.GameObjects.Image
  isTreasure: boolean
  isSpawner: boolean
  anim: IFrameAnim
  isAnimated: boolean
  i: number
  j: number
}

const objs: IObject[] = []
export function getAll() {
  return objs
}
export const getAllTreasure = () => {
  return l.filter(objs, (c) => c.isTreasure)
}
export const getSpawners = () => {
  return l.filter(objs, (c) => c.isSpawner)
}

export function playAnim(obj: IObject, ad: IFrameAnimData, force?: boolean) {
  obj.isAnimated = true
  anims.play(obj.anim, ad, force)
  updateAnimFrame(obj)
}
export function updateAnim(obj: IObject) {
  anims.update(obj.anim, () => {
    updateAnimFrame(obj)
  })
}
function updateAnimFrame(obj: IObject) {
  spriteMap.setFrame(obj.image, obj.anim.data.frames[obj.anim.frameIdx].fi)
}

export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

export const objectAnims = {
  def: anims.createAnimData([fi32(3, 3, 3)]),
  fire1: anims.createAnimData([fi32(3, 2, 7), fi32(3, 2, 8)]),
  fire2: anims.createAnimData([fi32(3, 2, 8), fi32(3, 2, 7)]),
}

export function create(
  x: number,
  y: number,
  i: number,
  j: number,
  data: ITileDataShip,
): IObject {
  let id = createId()

  let defaultFrame = data.frameInfo

  let image = spriteMap.createImageFromFrameInfo(
    layers.getLayers().objects,
    defaultFrame,
    x,
    y,
  )

  let anim = anims.create(objectAnims.def)
  let obj: IObject = {
    eType: 'object',
    id,
    image,
    isDead: false,
    i,
    j,
    isTreasure: false,
    isAnimated: false,
    isSpawner: false,
    anim,
  }
  // playAnim(obj, anim.data, true)

  if (data.name === 'fire_1') {
    playAnim(obj, objectAnims.fire1)
  }
  if (data.name === 'fire_2') {
    playAnim(obj, objectAnims.fire2)
  }
  if (data.name === 'gold') {
    obj.isTreasure = true
  }
  if (data.name.includes('ring')) {
    obj.isTreasure = true
  }
  if (data.name.includes('chest')) {
    obj.isTreasure = true
  }
  if (data.name.includes('gem')) {
    obj.isTreasure = true
  }
  if (data.name.includes('stair') && data.name.includes('up')) {
    obj.isSpawner = true
  }

  objs.push(obj)

  return obj
}

export function moveToTile(
  obj: IObject,
  map: ITileMapShip,
  x: number,
  y: number,
) {
  obj.image.x = map.ox + x * map.tileSize
  obj.image.y = map.oy + y * map.tileSize
  obj.i = x
  obj.j = y
}

export function kill(obj: IObject) {
  obj.isDead = true
  obj.image.tint = 0xccc
}
export function killAll() {
  l.forEach(objs, (c) => {
    kill(c)
  })
}
export function updateAll() {
  objs.forEach((c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
  })
}
function update(obj: IObject) {
  if (obj.isAnimated) {
    updateAnim(obj)
  }
}

// export function getAtMouse(mx: number, my: number) {
//   let found: IMonster | null = null

//   let r = 20

//   l.forEach(objs, (c) => {
//     if (c.image.x - r < mx && c.image.x + r / 2 > mx) {
//       if (c.image.y - r / 2 < my && c.image.y + r / 2 > my) {
//         found = c
//         return false
//       }
//     }
//   })
//   return found
// }
